import React, {useEffect, useState} from "react";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {useLocation} from "react-router-dom";

const Seo = props => {


    const {seo, configuration} = props
    const location = useLocation();
    const {pathname} = location;
    const [theSeo, setTheSeo] = useState({})
    const [segment, setSegment] = useState('')

    const getPathWithoutLang = (pathname) => {
        const segments = pathname.split('/').filter(Boolean); // remove empty strings
        return segments.slice(1).join('/'); // skip the lang part
    };

    // const trimmedPath = getPathWithoutLang(pathname);

    useEffect(() => {
        const lastSegment = getPathWithoutLang(pathname)
        setSegment(lastSegment)
    }, [pathname])
    useEffect(() => {
        setValidSeo(seo, configuration?.is_mirror ? 'mirror' : 'main', segment)
    }, [configuration?.is_mirror, seo, segment])

    const setValidSeo = (seo, domain, validSegment) => {
        // console.log('segment = ', segment)
        // console.log('configuration = ', configuration)
        if (!validSegment)
            validSegment = 'homepage'
        try {
            let validMe;
            const theSection = seo[domain] || null

            if (theSection) {
                validMe = theSection[validSegment] || null
                if (validMe)
                    validMe = validMe[0] || null
            }

            if (!validMe) {
                const theSection = seo['default'] || null

                if (theSection) {
                    validMe = theSection[validSegment] || theSection['default'] || null
                    if (validMe)
                        validMe = validMe[0] || null
                }
            }
            if (validMe)
                setTheSeo(validMe)
        } catch (e) {
            console.error(e)
            setTheSeo({})
        }
    }


    return (
        <HelmetProvider>
            <Helmet>
                <title>{theSeo?.seo_title || ''}</title>
                <meta name="description" content={theSeo?.seo_description || ''}/>
                <meta name="keywords" content={theSeo?.seo_keywords || ''}/>


                <meta property="og:title" content={theSeo?.seo_og_title || ''}/>
                <meta property="og:description" content={theSeo?.seo_og_description || ''}/>
                <meta property="og:url" content={theSeo?.seo_og_url || ''}/>
                <meta property="og:type" content={theSeo?.seo_og_type || ''}/>
                <meta property="og:site_name" content={theSeo?.seo_og_site_name || ''}/>


                <meta property="twitter:card" content={theSeo?.seo_twitter_card || ''}/>
                <meta property="twitter:title" content={theSeo?.seo_twitter_title || ''}/>
                <meta property="twitter:description" content={theSeo?.seo_twitter_description || ''}/>
                <meta property="twitter:image" content={theSeo?.seo_twitter_image || ''}/>


                <meta property="robots" content={theSeo?.seo_robots ||''}/>
                <link rel="canonical" href={theSeo?.seo_canonical ||''}/>


            </Helmet>
        </HelmetProvider>
    )
}


export default Seo
